export const TASK_STATUS = {
    PENDING: 1,
    CANCELLED: 2,
    IN_PROGRESS: 3,
    ERROR: 4,
    COMPLETED: 5
};
